
import { EmployeeType, PayrollType } from '@/types/enums.type';
import { OfficeDto } from '@/types/office.type';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { AcceptedShift, Shift } from '../shift.types';
import ShiftDeleteModal from './shift-delete-modal.vue';

@Component({
  components: {
    ShiftDeleteModal
  },
  computed: {
    ...mapState("Shift", 
    [
      "selectedOffice",
    ])
  }
})
export default class ShiftDetailModal extends Vue {
  @Prop() shift?: Shift | AcceptedShift;
  @Prop() isDelete!: boolean;
  selectedOffice!: OfficeDto;

  PayrollType = PayrollType;

  getEmployeeType(employeeType: EmployeeType): string {
    switch(employeeType) {
      case EmployeeType.WTwo:
        return 'W2';
      case EmployeeType.OneZeroNineNine:
        return '1099'
    }
  }

  getPayrollType(payrollType: PayrollType): string {
    switch(payrollType) {
      case PayrollType.EndOfDay:
        return 'End Of Day';
      case PayrollType.DirectDeposit:
        return 'Direct Deposit';
      default:
        return PayrollType[payrollType];
    }
  }

  closeModal(): void {
    this.$bvModal.hide('shift-detail-modal');
  }

  deleteShift(): void {
    this.$bvModal.show("shift-delete-modal");
  }

  onDelete(): void {
    this.$emit('delete');
    this.closeModal();
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const options = { month: 'long' } as Intl.DateTimeFormatOptions;
    const day = date.getDate();
    let daySuffix;

    switch (day) {
        case 1:
        case 21:
        case 31:
            daySuffix = 'st';
            break;
        case 2:
        case 22:
            daySuffix = 'nd';
            break;
        case 3:
        case 23:
            daySuffix = 'rd';
            break;
        default:
            daySuffix = 'th';
    }

    return `${date.toLocaleDateString('en-US', options)} ${day}${daySuffix}, ${date.getFullYear()}`;
  }
}
